import React from 'react';
import { compose } from '@beef/redux';
import { connect } from 'react-redux';
import { withMountListener } from '@beef/react';
import { Accordion } from '@carnica/ui-kit';
import { cnBem } from '@carnica/utils';
import { selectAccountsPending, selectAllAccountsWithoutSelected, selectBaseUrl, selectDefaultAccountsText, selectSelectedAccount } from "../../../store/selectors";
import { ActionCreator } from "../../../store/actions";
import { SelectedAccount } from "./components/SelectedAccount";
import { LinkedAccounts } from "./components/LinkedAccounts";
import { AccountsSkeleton } from "./components/AccountsSkeleton";
import styles from "./styles.pcss";
var cnAccordion = cnBem('accounts', styles);
export var _Accounts = function _Accounts(_ref) {
  var account = _ref.account,
    accounts = _ref.accounts,
    baseUrl = _ref.baseUrl,
    defaultAccountsText = _ref.defaultAccountsText,
    pending = _ref.pending,
    isOpen = _ref.isOpen,
    setIsOpen = _ref.setIsOpen;
  if (pending) {
    return /*#__PURE__*/React.createElement(AccountsSkeleton, {
      "data-t-id": "Container-Accounts"
    });
  }
  return /*#__PURE__*/React.createElement(Accordion, {
    label: /*#__PURE__*/React.createElement(SelectedAccount, {
      account: account,
      isOpen: isOpen
    }),
    onLabelClick: function onLabelClick() {
      return setIsOpen(!isOpen);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: cnAccordion(null, ['linked'])
  }, /*#__PURE__*/React.createElement(LinkedAccounts, {
    accounts: accounts,
    baseUrl: baseUrl,
    defaultAccountsText: defaultAccountsText
  })));
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    accounts: selectAllAccountsWithoutSelected(state),
    baseUrl: selectBaseUrl(state),
    defaultAccountsText: selectDefaultAccountsText(state),
    account: selectSelectedAccount(state),
    pending: selectAccountsPending(state)
  };
};
var mapDispatchToProps = {
  onMount: function onMount() {
    return function (dispatch) {
      dispatch(ActionCreator.fetchAccounts());
      dispatch(ActionCreator.fetchInitData());
    };
  }
};
export var Accounts = compose(connect(mapStateToProps, mapDispatchToProps), withMountListener)(_Accounts);